import React from "react";
import { Card, Row, Typography } from "antd";
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
// import { Icon } from "@iconify/react";
import { EditFilled } from "@ant-design/icons";

import { OverviewLeadManagement } from "./components/OverviewLeadManagement";

const { Title } = Typography;

export interface Props {
  baseUrl: any;
  accessRole: any;
  dataResult: any;
}

export const LeadDebtManagementRoute: React.FC<Props> = ({ baseUrl, accessRole, dataResult }): React.ReactElement => {
  const { push } = useHistory();
  const { path } = useRouteMatch();
  return (
    <>
      <Row
        gutter={[
          { xs: 8, sm: 16 },
          { xs: 8, sm: 16 },
        ]}
      >
        <Card style={{ width: "100%", textAlign: "left" }}>
          <Title style={{ color: "#0056B4", fontSize: "24px" }}>
            <EditFilled /> LEAD MANAGEMENT
          </Title>
        </Card>
      </Row>
      <Switch>
        <Route path={`${path}`}>
          <OverviewLeadManagement accessRole={accessRole} dataResult={dataResult} />
        </Route>
      </Switch>
    </>
  );
};
